<template>
  <div class="onotification" :class="notificationClasses">
    <div class="icon-container">
      <OSvg class="icon" :svg="svgIcon" />
    </div>
    <div class="text-container">
      <h3 class="ota-small" v-text="title" />
      <p class="ota-small-light" v-text="text" />
    </div>
    <button
      v-if="buttonText"
      type="button"
      class="button ota-small-semi"
      @click="$emit('click')"
      v-text="buttonText"
    />
  </div>
</template>

<script>
const OSvg = () => import('@/components/OSvg/OSvg')
export default {
  name: 'ONotification',
  components: { OSvg },
  props: {
    type: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: null
    },
    cornersRounded: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    notificationClasses () {
      const classes = []

      if (this.cornersRounded) {
        classes.push('rounded')
      }

      classes.push(`onotification-${this.type}`)

      return classes
    },
    svgIcon () {
      let icon = 'info'

      if (this.type === 'success') {
        icon = 'checkmark'
      } else if (this.type === 'warning') {
        icon = 'alert'
      } else if (this.type === 'danger') {
        icon = 'danger'
      }

      return icon
    }
  }
}
</script>

<style lang="postcss" scoped>
  .onotification {
    @apply relative flex items-stretch text-white;

    &-info {
      @apply bg-info;

      .button {
        @apply bg-info-dark;
      }
    }
    &-success {
      @apply bg-success;

      .button {
        @apply bg-success-dark;
      }
    }
    &-warning {
      @apply bg-warning;

      .button {
        @apply bg-warning-dark;
      }
    }
    &-danger {
      @apply bg-danger;

      .button {
        @apply bg-danger-dark;
      }
    }

    .icon-container {
      @apply flex items-center pl-4 w-10;

      .icon {
        @apply fill-current text-white w-full;
      }
    }

    .text-container {
      @apply p-4 w-full;

      h3 {
        @apply mb-1;
      }
    }

    .button {
      @apply relative px-4 rounded-r whitespace-no-wrap;
    }
  }
</style>
